<script lang="ts" setup>
import { type ToMetaTagsType, toHead } from "vue-datocms";

definePageMeta({
  layout: "anonymous",
  auth: false,
});

const { slug } = useRoute().params;
const { locale } = useI18n();
const { data } = await useFetch("/api/cms/legal/detail", {
  query: { slug: slug, locale: locale },
});

if (!data.value) {
  throw create404Error();
}

useDatoSlugsToI18n(data.value._allSlugLocales);

useHead(() => {
  if (!data.value?._seoMetaTags) {
    return {};
  }

  return toHead(data.value._seoMetaTags as ToMetaTagsType);
});
</script>

<template>
  <UContainer class="mx-auto mb-9xl mt-4xl max-w-[800px]">
    <article v-if="data" class="my-5">
      <h1 class="text-darkest">
        {{ data.title }}
      </h1>

      <StructuredContent :data="data.content" />
    </article>
  </UContainer>
</template>

<style>

</style>
